import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackValuationCTA = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'valuation promo'
    });
};
